import moment from "moment";

export const filterHospitalData = subscription => {
  const hospitalReportsList = subscription.data.hospitalReport.map(report => {
    return report;
  });

  const hospitalStatistics = (graphLabel, graphColor, graphDataKey) => {
    return {
      label: graphLabel,
      backgroundColor: graphColor,
      data: hospitalReportsList.map(dataPoint => {
        return dataPoint[graphDataKey];
      })
    };
  };

  let numberOfCalls = hospitalStatistics(
    "Number of COVID related calls",
    "rgba(25, 85, 121, 0.7)",
    "numberOfCalls"
  );

  let patientsTested = hospitalStatistics(
    "Patients tested for COVID",
    "rgba(134, 179, 205, 0.7)",
    "patientsTested"
  );

  let positivePatientTests = hospitalStatistics(
    "Patients with positive tests",
    "rgba(34, 116, 165, 0.5)",
    "positivePatientTests"
  );

  let negativePatientTests = hospitalStatistics(
    "Patients with negative tests",
    "rgba(124, 234, 156, 0.7)",
    "negativePatientTests"
  );

  let patientsAdmitted = hospitalStatistics(
    "Patients admitted, suspected COVID",
    "rgba(237, 174, 73, 0.7)",
    "patientsAdmittedSuspectedCovid"
  );

  let wardBedsConsumed = hospitalStatistics(
    "Ward beds consumed, suspected COVID",
    "rgba(252, 127, 133, 0.7)",
    "wardBedsSuspectedCovid"
  );

  let icuBedsConsumed = hospitalStatistics(
    "ICU beds consumed, suspected COVID",
    "rgba(252, 127, 133, 0.7)",
    "icuBedsSuspectedCovid"
  );

  let dataSets = {
    numberOfCalls: numberOfCalls,
    patientsTested: patientsTested,
    positivePatientTests: positivePatientTests,
    negativePatientTests: negativePatientTests,
    patientsAdmitted: patientsAdmitted,
    wardBedsConsumed: wardBedsConsumed,
    icuBedsConsumed: icuBedsConsumed
  };

  let dateRange = hospitalReportsList.map(report => {
    return moment(report.dateStamp).format("DD/MM");
  });

  return {
    dateRange: dateRange,
    dataSets: dataSets
  };
};
